import React from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";

const STAGES = [
    { key: "review", label: "Review Berkas" },
    { key: "apply", label: "Pendaftaran Kampus" },
    { key: "loa", label: "LoA Terbit" },
    { key: "visa", label: "Pengurusan Visa" },
    { key: "depart", label: "Siap Berangkat" },
];

export default function PortalCTA() {
    const navigate = useNavigate();
    return (
        <section id="portal" className="bg-white py-20 md:py-28" data-testid="portal-cta-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="bg-gradient-to-br from-[#0A1A2F] to-[#11294A] rounded-3xl p-8 md:p-14 text-white relative overflow-hidden">
                    <div className="absolute -top-20 -right-20 w-80 h-80 bg-[#F5A623]/20 rounded-full blur-3xl" />
                    <div className="relative grid md:grid-cols-2 gap-10 items-center">
                        <div>
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 text-xs font-semibold mb-5 border border-white/20">
                                <ShieldCheck className="w-3.5 h-3.5 text-[#F5A623]" />
                                PORTAL KLIEN
                            </div>
                            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
                                Pelacak Aplikasi Real-time
                            </h2>
                            <p className="mt-4 text-slate-300 text-base max-w-md">
                                Login sekali, pantau seluruh perjalananmu dari review berkas hingga keberangkatan, Kak. Transparan dan aman.
                            </p>
                            <button
                                onClick={() => navigate("/login")}
                                data-testid="portal-login-cta"
                                className="mt-7 inline-flex items-center gap-2 bg-[#F5A623] text-[#0A1A2F] hover:bg-[#D98F1B] rounded-full px-7 py-3.5 font-bold transition-all"
                            >
                                <LogIn className="w-4 h-4" /> Masuk Portal Klien
                            </button>
                        </div>

                        <div className="space-y-3">
                            {STAGES.map((s, i) => (
                                <div
                                    key={s.key}
                                    className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-2xl px-5 py-4"
                                    data-testid={`stage-preview-${s.key}`}
                                >
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs ${i === 0 ? "bg-[#F5A623] text-[#0A1A2F]" : "bg-white/10 text-white/60"}`}>
                                        {i + 1}
                                    </div>
                                    <div className="flex-1 font-medium">{s.label}</div>
                                    {i === 0 && <span className="text-[10px] uppercase tracking-widest text-[#F5A623] font-bold">Aktif</span>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
